import React from "react";
import { motion } from "framer-motion";
import { FaPaw, FaDog, FaHome, FaHandshake } from "react-icons/fa";
import "./ServicesSection.css";

const services = [
  {
    icon: <FaPaw />,
    title: "Puppy Adoption",
    desc: "Find your AKC-registered golden retriever, raised with love and transparency from day one.",
    cta: { text: "See Available Puppies", link: "/puppies" }
  },
  {
    icon: <FaHandshake />,
    title: "Stud Services",
    desc: "Carefully selected AKC studs with health clearances available to approved breeders. Get in touch to inquire.",
    cta: { text: "Stud Info", link: "/studs" }
  },
  {
    icon: <FaHome />,
    title: "Lifetime Support",
    desc: "We’re here for every puppy we place, questions, advice, or just sharing milestones. Reach out any time.",
    cta: null
  },
  {
    icon: <FaDog />,
    title: "Farm Visits",
    desc: "Come visit the puppies, meet Cary, and see where your new best friend is raised.",
    cta: { text: "Contact Us", link: "/contact" }
  },
];

export default function ServicesSection() {
  return (
    <section className="services-section">
      <div className="services-card">
        <h2 className="services-title">What We Offer</h2>
        <p className="services-subtitle">
          More than puppies. Lifelong support, transparency, and a real family experience.
        </p>
        <div className="services-list">
          {services.map((service, i) => (
            <motion.div
              className="service-card"
              key={i}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              viewport={{ once: true }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-desc">{service.desc}</p>
              {service.cta && (
                <a href={service.cta.link} className="service-btn">{service.cta.text}</a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}